import { useQuery } from '@tanstack/react-query'
import { useAppStore } from '@/store/appStore'
import { resolveSystemRole } from '@/hooks/useAuthorization'
import { isAdminSystemRole } from '@/types/authorization'
import { isTicketingAdmin } from '../services/ticketingService'

export const TICKETING_ADMIN_QUERY_KEY = ['it-ticketing', 'is-admin'] as const

/**
 * May this user open the Admin page and change ticketing settings? A
 * Tesseract admin always may; anyone else only if they are on the ticketing
 * admin list (00589). The answer comes from it_ticketing_is_admin(), the same
 * function RLS uses, so the UI never offers a change the database refuses.
 */
export function useTicketingAdmin(enabled = true) {
  const role = useAppStore((s) => s.currentUser.role)
  const isAppAdmin = isAdminSystemRole(resolveSystemRole(role))
  const q = useQuery({
    queryKey: TICKETING_ADMIN_QUERY_KEY,
    queryFn: isTicketingAdmin,
    enabled: enabled && !isAppAdmin,
    staleTime: 60_000,
    retry: false,
  })
  return {
    isAdmin: isAppAdmin || q.data === true,
    /** Only a Tesseract admin can change who is on the admin list. */
    isAppAdmin,
    isLoading: !isAppAdmin && enabled && q.isLoading,
  }
}
